









import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class EnabledStatusLabel extends Vue {
  @Prop({type: Number, required: true}) enabled: number;

  get color() {
    switch (this.enabled) {
      case 1:
        return 'green';
      default:
        return 'red';
    }
  }
}
